import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './transaction-details.reducer';
import { APP_DATE_FORMAT } from 'app/config/constants';

export const TransactionDetails = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const transactionDetailsList = useAppSelector(state => state.transactionDetails?.entities);
  const loading = useAppSelector(state => state.transactionDetails?.loading);
  const totalItems = useAppSelector(state => state.transactionDetails?.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="transaction-details-heading" data-cy="TransactionDetailsHeading">
        <Translate contentKey="fitengineerBackendV2App.transactionDetails.home.title">Transaction Details</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fitengineerBackendV2App.transactionDetails.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/transaction-details/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fitengineerBackendV2App.transactionDetails.home.createLabel">Create new Transaction Details</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {transactionDetailsList && transactionDetailsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('paymentTransactionId')}>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.paymentTransactionId">Payment Transaction Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paymentTransactionId')} />
                </th>
                <th className="hand" onClick={sort('product')}>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.product">Product</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('product')} />
                </th>

                <th className="hand" onClick={sort('productName')}>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.productName">Product Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productName')} />
                </th>
                <th className="hand" onClick={sort('productId')}>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.productId">Product Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productId')} />
                </th>
                <th
                  className="hand"
                  // onClick={sort('product')}
                >
                  {/* <Translate contentKey="fitengineerBackendV2App.transactionDetails.product"> */}
                  Amount
                  {/* </Translate> */} {/* <FontAwesomeIcon icon={getSortIconByFieldName('product')} /> */}
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  <Translate contentKey="userManagement.createdDate">Created Date</Translate>
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fitengineerBackendV2App.transactionDetails.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  {/* <Translate contentKey="fitengineerBackendV2App.transactionDetails.user"> */}
                  ImportantUserDetails
                  {/* </Translate> */} {/* <FontAwesomeIcon icon="sort" /> */}
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {transactionDetailsList.map((transactionDetails, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/transaction-details/${transactionDetails.id}`} color="link" size="sm">
                      {transactionDetails.id}
                    </Button>
                  </td>
                  <td>{transactionDetails.paymentTransactionId}</td>
                  <td>{transactionDetails.product}</td>
                  <td>{transactionDetails.productName}</td>
                  <td>{transactionDetails.productId}</td>
                  <td>{transactionDetails.amount}</td>
                  <td>
                    {transactionDetails.createdDate ? (
                      <TextFormat value={transactionDetails.createdDate} type="date" format={APP_DATE_FORMAT} blankOnInvalid />
                    ) : null}
                  </td>
                  <td>
                    <Button tag={Link} to={`/admin/user-management/${transactionDetails.user.login}`} color="link" size="sm">
                      {transactionDetails.user ? transactionDetails.user.login : ''}
                    </Button>
                  </td>

                  <td>
                    <Button tag={Link} to={`/important-user-details/${transactionDetails.importantUserDetails.id}`} color="link" size="sm">
                      {transactionDetails.importantUserDetails ? transactionDetails.importantUserDetails.id : ''}
                    </Button>
                  </td>

                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/transaction-details/${transactionDetails.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/transaction-details/${transactionDetails.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/transaction-details/${transactionDetails.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fitengineerBackendV2App.transactionDetails.home.notFound">No Transaction Details found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={transactionDetailsList && transactionDetailsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TransactionDetails;
